import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useStore } from 'src/stores';
import React, { useEffect, useState } from 'react';
import { Button, MenuItem, Checkbox, Typography, ListItemText, IconButton, Chip } from '@mui/material';
import { BackdropLoader, toast, SelectMenu, Icon, BasicTooltip } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';
import useStyles from './style';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import AddTeamMemberModal from 'src/components/settings/AddTeamMemberModal';
export const ContactInformationModalContent = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2;
  let handleClose = _ref.handleClose;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const CONTACT_TYPES = {
    PRIMARY: 'Building',
    SECONDARY: 'Utility'
  };
  const primaryContactsInitialList = toJS((_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyInformation) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.propertyContacts) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.filter(pC => pC.contactType === CONTACT_TYPES.PRIMARY));
  const _useState = useState(primaryContactsInitialList),
    _useState2 = _slicedToArray(_useState, 2),
    primaryContacts = _useState2[0],
    setPrimaryContacts = _useState2[1];
  const secondaryContactsInitialList = toJS((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.propertyInformation) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.propertyContacts) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.filter(pC => pC.contactType === CONTACT_TYPES.SECONDARY));
  const _useState3 = useState(secondaryContactsInitialList),
    _useState4 = _slicedToArray(_useState3, 2),
    secondaryContacts = _useState4[0],
    setSecondaryContacts = _useState4[1];
  const _useState5 = useState(primaryContacts.filter(pC => secondaryContacts.findIndex(sC => sC.teamMemberId === pC.teamMemberId) === -1).length === 0 && secondaryContacts.filter(sC => primaryContacts.findIndex(pC => sC.teamMemberId === pC.teamMemberId) === -1).length === 0),
    _useState6 = _slicedToArray(_useState5, 2),
    isSecondarySameAsPrimary = _useState6[0],
    setIsSecondarySameAsPrimary = _useState6[1];
  const submitForm = async event => {
    event.stopPropagation();
    event.preventDefault();
    await store.properties.updatePropertysContactsAsync.run({
      propertyId: store.homeDashboardStore.getCurrentProperty.id,
      data: {
        toCreate: [...((primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.map(pC => ({
          contactType: pC.contactType,
          teamMemberId: pC.teamMemberId
        })).filter(teamMemberId => primaryContactsInitialList.findIndex(i => i.teamMemberId === teamMemberId.teamMemberId) === -1)) || []), ...((secondaryContacts === null || secondaryContacts === void 0 ? void 0 : secondaryContacts.map(sC => ({
          contactType: sC.contactType,
          teamMemberId: sC.teamMemberId
        })).filter(teamMemberId => secondaryContactsInitialList.findIndex(i => i.teamMemberId === teamMemberId.teamMemberId) === -1)) || [])],
        toDelete: [...primaryContactsInitialList.filter(teamMember => !primaryContacts.find(pc => pc.teamMemberId === teamMember.teamMemberId)), ...secondaryContactsInitialList.filter(teamMember => !secondaryContacts.find(sc => sc.teamMemberId === teamMember.teamMemberId))]
      }
    }, [store.homeDashboardStore.getCurrentProperty.id]).then(resp => {
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        toast('success', {
          body: ['Contact information saved!']
        });
        handleClose();
      }
      store.homeDashboardStore.getCurrentProperty.fetchContacts();
    });
  };
  const TeamMemberSelect = observer(_ref2 => {
    let type = _ref2.type;
    const _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      searchKey = _useState8[0],
      setSearchKey = _useState8[1];
    const _useState9 = useState(false),
      _useState0 = _slicedToArray(_useState9, 2),
      isTeamMemberSelectOpen = _useState0[0],
      setIsTeamMemberSelectOpen = _useState0[1];
    return /*#__PURE__*/React.createElement(SelectMenu, {
      id: 'contacts-selector-' + type,
      key: 'contacts-selector-' + type,
      value: null,
      label: t('Select Team Member'),
      labelId: "contacts-selector-label",
      onChange: event => {
        event.stopPropagation();
        event.preventDefault();
      },
      enableSearch: true,
      onSearch: key => setSearchKey(key),
      handleClose: () => {
        setSearchKey('');
        setIsTeamMemberSelectOpen(false);
      },
      handleOpen: () => setIsTeamMemberSelectOpen(true),
      isOpen: isTeamMemberSelectOpen,
      enableAddAction: true,
      addActionButton: /*#__PURE__*/React.createElement(Button, {
        variant: "menuAction",
        onClick: () => {
          setIsTeamMemberSelectOpen(false);
          setTimeout(() => {
            document.getElementById('ContactInformationModalAddNewTeammember').click();
          }, 5);
        },
        'custom-attribute': '774-new-billing-module-primary-contacts'
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "plus-circle"
      }), t('team_page.add_new_team_member')),
      renderValue: () => {}
    }, store.homeDashboardStore.getCurrentCompany.teamMembers.filter(companyTeamMember => {
      const searchPhrase = new RegExp(searchKey, 'gi');
      return searchKey.length > 0 ? " ".concat(companyTeamMember.getFullName).search(searchPhrase) > 0 || " ".concat(companyTeamMember.getEmail).search(searchPhrase) > 0 : true;
    }).map(companyTeamMember => {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: companyTeamMember.id,
        value: companyTeamMember.id,
        variant: "multiple",
        onClick: event => {
          event.stopPropagation();
          event.preventDefault();
          if (type === CONTACT_TYPES.PRIMARY) {
            if (primaryContacts.findIndex(primaryContact => primaryContact.teamMemberId === companyTeamMember.id) !== -1) {
              setPrimaryContacts(primaryContacts.filter(primaryContact => primaryContact.teamMemberId !== companyTeamMember.id));
            } else {
              setPrimaryContacts([...primaryContacts, {
                teamMemberId: companyTeamMember.id,
                contactType: CONTACT_TYPES.PRIMARY
              }]);
            }
          }
          if (type === CONTACT_TYPES.SECONDARY || isSecondarySameAsPrimary) {
            if (secondaryContacts.findIndex(secondaryContact => secondaryContact.teamMemberId === companyTeamMember.id) !== -1) {
              setSecondaryContacts(secondaryContacts.filter(secondaryContact => secondaryContact.teamMemberId !== companyTeamMember.id));
            } else {
              setSecondaryContacts([...secondaryContacts, {
                teamMemberId: companyTeamMember.id,
                contactType: CONTACT_TYPES.SECONDARY
              }]);
            }
          }
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: type === CONTACT_TYPES.PRIMARY ? primaryContacts.findIndex(primaryContact => primaryContact.teamMemberId === companyTeamMember.id) !== -1 : secondaryContacts.findIndex(secondaryContact => secondaryContact.teamMemberId === companyTeamMember.id) !== -1
      }), /*#__PURE__*/React.createElement(ListItemText, {
        primary: companyTeamMember.getFullName,
        secondary: companyTeamMember.getEmail
      }));
    }));
  });
  const TeamMemberListItem = observer(_ref3 => {
    var _item$firstName;
    let item = _ref3.item,
      type = _ref3.type,
      status = _ref3.status;
    return /*#__PURE__*/React.createElement("div", {
      key: item.accountId,
      className: "".concat(classes.teamMember)
    }, /*#__PURE__*/React.createElement("div", {
      key: item.accountId,
      className: classes.teamMemberInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.avatar
    }, (_item$firstName = item.firstName) === null || _item$firstName === void 0 ? void 0 : _item$firstName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      className: classes.teamMemberListItemContactInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.teamMemberName
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body"
    }, "".concat(item.firstName, " ").concat(item.lastName)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, item.getEmail)), /*#__PURE__*/React.createElement("div", {
      className: classes.teamMemberStatus
    }, status === 'pending' && /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "mail-send"
      }),
      variant: "warning",
      label: t('general.pending')
    }), status === 'active' && /*#__PURE__*/React.createElement(Chip, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "mail-success"
      }),
      variant: "success",
      label: t('general.active')
    })))), /*#__PURE__*/React.createElement("div", {
      className: classes.teamMemberActions
    }, /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: type === CONTACT_TYPES.PRIMARY ? (primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.length) <= 1 ? t('You cannot remove last primary contact!') : null : (secondaryContacts === null || secondaryContacts === void 0 ? void 0 : secondaryContacts.length) <= 1 && !isSecondarySameAsPrimary ? t('You cannot remove last secondary contact, either one must be selected or set checkbox same as primary!') : null,
      placement: "top"
    }, type === CONTACT_TYPES.PRIMARY && (primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.length) <= 1 || type === CONTACT_TYPES.SECONDARY && (secondaryContacts === null || secondaryContacts === void 0 ? void 0 : secondaryContacts.length) <= 1 && !isSecondarySameAsPrimary ? /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    })) : /*#__PURE__*/React.createElement(IconButton, {
      onClick: event => {
        event.stopPropagation();
        event.preventDefault();
        if (type === CONTACT_TYPES.PRIMARY) {
          setPrimaryContacts(primaryContacts.filter(pC => pC.teamMemberId !== item.id));
          if (isSecondarySameAsPrimary) {
            setSecondaryContacts(secondaryContacts.filter(sC => sC.teamMemberId !== item.id));
          }
        } else if (type === CONTACT_TYPES.SECONDARY) {
          setSecondaryContacts(secondaryContacts.filter(pC => pC.teamMemberId !== item.id));
        }
      },
      'custom-attribute': '341-ManageAccessModal'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "trash"
    }))))));
  });
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.contentBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.primaryContentBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h4'
  }, t('Primary Contact')), /*#__PURE__*/React.createElement(Typography, {
    variant: 'body1'
  }, t('Who gets notifications about the whole property.'))), /*#__PURE__*/React.createElement(TeamMemberSelect, {
    key: 'Primary-TeamMemberSelect',
    type: CONTACT_TYPES.PRIMARY
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.teamMemberList
  }, primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.map(item => {
    return /*#__PURE__*/React.createElement(TeamMemberListItem, {
      key: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId).accountId,
      item: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId),
      status: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId).emailConfirmed ? 'active' : 'pending',
      type: CONTACT_TYPES.PRIMARY
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.secondaryContentBody
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h4'
  }, t('Secondary Contact')), /*#__PURE__*/React.createElement(Typography, {
    variant: 'body1'
  }, t('Who gets notifications the utilities only.'))), /*#__PURE__*/React.createElement("div", {
    className: classes.secondarySameAsPrimary,
    onClick: () => {
      if (!isSecondarySameAsPrimary) {
        setSecondaryContacts((primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.map(pC => ({
          teamMemberId: pC.teamMemberId,
          contactType: CONTACT_TYPES.SECONDARY
        }))) || []);
      }
      setIsSecondarySameAsPrimary(!isSecondarySameAsPrimary);
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSecondarySameAsPrimary
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: 'body1'
  }, t('Same as primary contact'))), !isSecondarySameAsPrimary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TeamMemberSelect, {
    key: 'Secondary-TeamMemberSelect',
    type: CONTACT_TYPES.SECONDARY
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.teamMemberList
  }, secondaryContacts === null || secondaryContacts === void 0 ? void 0 : secondaryContacts.map(item => {
    return /*#__PURE__*/React.createElement(TeamMemberListItem, {
      key: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId).accountId,
      item: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId),
      status: store.homeDashboardStore.getCurrentCompany.companyTeamMemberDetails(item.teamMemberId).emailConfirmed ? 'active' : 'pending',
      type: CONTACT_TYPES.SECONDARY
    });
  }))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => handleClose(),
    'custom-attribute': '860-new-billing-module-ContactInformationModalContent'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: (primaryContacts === null || primaryContacts === void 0 ? void 0 : primaryContacts.length) < 1 || (secondaryContacts === null || secondaryContacts === void 0 ? void 0 : secondaryContacts.length) < 1 && !isSecondarySameAsPrimary || store.properties.updatePropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress,
    onClick: submitForm,
    type: "button",
    variant: "contained",
    'custom-attribute': '861-new-billing-module-ContactInformationModalContent'
  }, t('general.save_and_close')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.properties.updatePropertysContactsAsync.inProgress || store.teamMembers.getCompanyTeamMembersAsync.inProgress
  }), /*#__PURE__*/React.createElement(AddTeamMemberModal, {
    customTrigger: /*#__PURE__*/React.createElement("i", {
      id: "ContactInformationModalAddNewTeammember"
    }),
    handleEditModalSuccess: () => {
      store.homeDashboardStore.getCurrentCompany.fetchCompanyTeamMembers({
        customInProgressFetchId: store.homeDashboardStore.getCurrentProperty.id
      });
      store.homeDashboardStore.getCurrentProperty.fetchContacts();
    }
  }));
});